<div style="display: flex; flex-direction:row; flex-wrap:nowrap; padding: 5px" (click)="toggleState()">
    <i class="material-icons" style="vertical-align: middle !important;" [class.checked]="checked">check_box</i>
    <span>{{text}}</span>
</div>
@if (showSeparator) {
  <hr class="divider" />
}
